import { CanActivate, Router, UrlTree } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { AuthService } from '../../auth/services/auth.service';
import { IAppState } from '../../store/interface/app.state.interface';
import { LOGIN_ROUTE } from '../constant/route.constant';
import { selectLoggedInUser } from '../../store/user/user.selectors';
import { TokenStoreService } from '../services/token-store.service';

@Injectable({ providedIn: 'root' })
export class SignedInGuard implements CanActivate {
    private readonly authService = inject(AuthService);
    private readonly router = inject(Router);
    private readonly store = inject(Store<IAppState>);
    private readonly tokenStore = inject(TokenStoreService);
    private readonly loggedInUser = this.store.selectSignal(selectLoggedInUser);

    // After a page refresh the store is empty, so a saved token is checked with the API.
    // A bad one gets the API's toast from the interceptor, which also clears it.
    async canActivate(): Promise<boolean | UrlTree> {
        if (this.loggedInUser()) return true;
        if (!this.tokenStore.read()) return this.router.parseUrl(LOGIN_ROUTE);

        return this.authService
            .fetchLoggedInUser()
            .then(() => true)
            .catch(() => this.router.parseUrl(LOGIN_ROUTE));
    }
}
